<template>
  <b-card class="main">
    <b-card no-body :header="$t('pages.user_terms.title')">
      <b-list-group flush>
        <b-list-group-item>
          <section
            class="mt-3"
            v-html="
              $t(comOnly ? 'user.general_terms_ComOnly' : 'user.general_terms')
            "
          />
          <b-button v-b-modal.terms
            ><b-icon icon="chevron-right" />{{
              $t('pages.user_terms.servicestart_general_terms')
            }}</b-button
          >
        </b-list-group-item>
      </b-list-group>
    </b-card>

    <b-modal
      id="terms"
      :title="$t('pages.user_terms.menu')"
      ok-only
      :ok-title="$t('buttons.close')"
      size="lg"
      scrollable
    >
      <b-embed
        type="iframe"
        :src="
          `https://se.servicestart.com/account/info/terms/terms_${this.getUserLocale()}.jsp`
        "
        sandbox
      />
    </b-modal>
  </b-card>
</template>
<script>
export default {
  computed: {
    comOnly() {
      return this.$route.params['com_only'];
    },
    userLanguage() {
      return this.$route.params['lang'];
    },
    userCountry() {
      return this.$route.params['country'];
    },
  },
  methods: {
    getUserLocale() {
      switch (this.$i18n.locale) {
        case 'en':
          return 'en_GB';
        case 'fr':
          return 'fr_CH';
        case 'sv':
          return 'sv_SE';
      }
    },
  },
};
</script>
